// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*:where(.mtw,.mtw *),
::before:where(.mtw,.mtw *),
::after:where(.mtw,.mtw *) {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before:where(.mtw,.mtw *),
::after:where(.mtw,.mtw *) {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

.mtw {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

.mtw {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr:where(.mtw,.mtw *) {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]):where(.mtw,.mtw *) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1:where(.mtw,.mtw *),
h2:where(.mtw,.mtw *),
h3:where(.mtw,.mtw *),
h4:where(.mtw,.mtw *),
h5:where(.mtw,.mtw *),
h6:where(.mtw,.mtw *) {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a:where(.mtw,.mtw *) {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b:where(.mtw,.mtw *),
strong:where(.mtw,.mtw *) {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code:where(.mtw,.mtw *),
kbd:where(.mtw,.mtw *),
samp:where(.mtw,.mtw *),
pre:where(.mtw,.mtw *) {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small:where(.mtw,.mtw *) {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub:where(.mtw,.mtw *),
sup:where(.mtw,.mtw *) {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub:where(.mtw,.mtw *) {
  bottom: -0.25em;
}

sup:where(.mtw,.mtw *) {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table:where(.mtw,.mtw *) {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button:where(.mtw,.mtw *),
input:where(.mtw,.mtw *),
optgroup:where(.mtw,.mtw *),
select:where(.mtw,.mtw *),
textarea:where(.mtw,.mtw *) {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button:where(.mtw,.mtw *),
select:where(.mtw,.mtw *) {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button:where(.mtw,.mtw *),
input:where([type='button']):where(.mtw,.mtw *),
input:where([type='reset']):where(.mtw,.mtw *),
input:where([type='submit']):where(.mtw,.mtw *) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring:where(.mtw,.mtw *) {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid:where(.mtw,.mtw *) {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress:where(.mtw,.mtw *) {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button:where(.mtw,.mtw *),
::-webkit-outer-spin-button:where(.mtw,.mtw *) {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search']:where(.mtw,.mtw *) {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration:where(.mtw,.mtw *) {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button:where(.mtw,.mtw *) {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary:where(.mtw,.mtw *) {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote:where(.mtw,.mtw *),
dl:where(.mtw,.mtw *),
dd:where(.mtw,.mtw *),
h1:where(.mtw,.mtw *),
h2:where(.mtw,.mtw *),
h3:where(.mtw,.mtw *),
h4:where(.mtw,.mtw *),
h5:where(.mtw,.mtw *),
h6:where(.mtw,.mtw *),
hr:where(.mtw,.mtw *),
figure:where(.mtw,.mtw *),
p:where(.mtw,.mtw *),
pre:where(.mtw,.mtw *) {
  margin: 0;
}

fieldset:where(.mtw,.mtw *) {
  margin: 0;
  padding: 0;
}

legend:where(.mtw,.mtw *) {
  padding: 0;
}

ol:where(.mtw,.mtw *),
ul:where(.mtw,.mtw *),
menu:where(.mtw,.mtw *) {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog:where(.mtw,.mtw *) {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea:where(.mtw,.mtw *) {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder:where(.mtw,.mtw *), textarea::-moz-placeholder:where(.mtw,.mtw *) {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder:where(.mtw,.mtw *),
textarea::placeholder:where(.mtw,.mtw *) {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button:where(.mtw,.mtw *),
[role="button"]:where(.mtw,.mtw *) {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled:where(.mtw,.mtw *) {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img:where(.mtw,.mtw *),
svg:where(.mtw,.mtw *),
video:where(.mtw,.mtw *),
canvas:where(.mtw,.mtw *),
audio:where(.mtw,.mtw *),
iframe:where(.mtw,.mtw *),
embed:where(.mtw,.mtw *),
object:where(.mtw,.mtw *) {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img:where(.mtw,.mtw *),
video:where(.mtw,.mtw *) {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(.mtw,.mtw *) {
  display: none;
}

.mtw {
    --background: 0 0% 100%;
    --foreground: 248, 88%, 19%;

    --muted: 210 40% 96.1%;
    --muted-foreground: 215.4 16.3% 46.9%;

    --popover: 0 0% 100%;
    --popover-foreground: 222.2 84% 4.9%;

    --card: 0 0% 100%;
    --card-foreground: 222.2 84% 4.9%;
    --card-installed: 223 33% 96%; /* #F1F3F8 */

    --border: 214.3 31.8% 91.4%;
    --input: 214.3 31.8% 91.4%;

    --primary: 229 20% 30%;
    --primary-foreground: 210 40% 98%;

    --secondary: 248 88% 19%;
    --secondary-foreground: 222.2 47.4% 11.2%;

    --accent: 210 40% 96.1%;
    --accent-foreground: 222.2 47.4% 11.2%;

    --destructive: 353 72% 43%;
    --destructive-foreground: 210 40% 98%;

    --ring: 215 20.2% 65.1%;

    --radius: 0.5rem;

    /* Skeleton */
    --skeleton: 0, 0%, 96%;
    --skeleton-foreground: 0, 0%, 85%;

    /* Backgrounds */
    --primary-dark: 248, 77%, 21%; /* #1C1769 */
    --background-default: 220, 22%, 98%; /* #F7F8FA */
    --background-installed: 223, 14%, 96%; /* #F1F3F8 */
    --primary-default: 248, 88%, 19%; /* #17125B */
    --primary-light: 223, 89%, 60%; /* #4368F8 */
    --filter-selected-background: 223, 89%, 90%; /* approximated from rgba(67, 104, 248, 0.10) */
    --background-navigation: 223, 24%, 97%; /* #F3F6FA */
    --background-detail: 223, 28%, 94%; /* #E9EFF6 */
    --background-loading: 0, 0%, 96%; /* #F5F5F5 */

    /* Accents */
    --accent-error: 353, 72%, 43%; /* #B50E32 */
    --accent-highlight: 342, 88%, 66%; /* #EB315A */
    --section-selected: 232, 59%, 51%; /* #3753BF */

    /* Texts & Borders */
    --border-hover: 234, 12%, 95%; /* #EAEAF4 */
    --border-default: 235, 8%, 96%; /* #F3F3F9 */
    --border-active: 0, 0%, 85%; /* #D9D9D9 */
    --text-default: 229, 20%, 30%; /* #414554 */
    --text-info: 0, 0%, 66%; /* #A9A9A9 */
    --text-subtle: 0, 0%, 55%; /* #8D8D8D */
    --filter-active-background: 0, 0%, 94%; /* #F0F0F0 */
  }

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}

@media (min-width: 1400px) {

  .container {
    max-width: 1400px;
  }
}

.mtw :is(.sr-only) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.mtw :is(.fixed) {
  position: fixed;
}

.mtw :is(.absolute) {
  position: absolute;
}

.mtw :is(.relative) {
  position: relative;
}

.mtw :is(.inset-0) {
  inset: 0px;
}

.mtw :is(.left-2) {
  left: 0.5rem;
}

.mtw :is(.left-\\[50\\%\\]) {
  left: 50%;
}

.mtw :is(.right-4) {
  right: 1rem;
}

.mtw :is(.top-4) {
  top: 1rem;
}

.mtw :is(.top-\\[50\\%\\]) {
  top: 50%;
}

.mtw :is(.z-50) {
  z-index: 50;
}

.mtw :is(.-mx-1) {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.mtw :is(.my-1) {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.mtw :is(.ml-auto) {
  margin-left: auto;
}

.mtw :is(.mr-2) {
  margin-right: 0.5rem;
}

.mtw :is(.mt-2) {
  margin-top: 0.5rem;
}

.mtw :is(.mt-8) {
  margin-top: 2rem;
}

.mtw :is(.line-clamp-1) {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.mtw :is(.line-clamp-2) {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.mtw :is(.line-clamp-4) {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.mtw :is(.flex) {
  display: flex;
}

.mtw :is(.inline-flex) {
  display: inline-flex;
}

.mtw :is(.grid) {
  display: grid;
}

.mtw :is(.h-1) {
  height: 0.25rem;
}

.mtw :is(.h-10) {
  height: 2.5rem;
}

.mtw :is(.h-11) {
  height: 2.75rem;
}

.mtw :is(.h-12) {
  height: 3rem;
}

.mtw :is(.h-2) {
  height: 0.5rem;
}

.mtw :is(.h-20) {
  height: 5rem;
}

.mtw :is(.h-3) {
  height: 0.75rem;
}

.mtw :is(.h-3\\.5) {
  height: 0.875rem;
}

.mtw :is(.h-4) {
  height: 1rem;
}

.mtw :is(.h-5) {
  height: 1.25rem;
}

.mtw :is(.h-6) {
  height: 1.5rem;
}

.mtw :is(.h-72) {
  height: 18rem;
}

.mtw :is(.h-9) {
  height: 2.25rem;
}

.mtw :is(.h-full) {
  height: 100%;
}

.mtw :is(.h-px) {
  height: 1px;
}

.mtw :is(.min-h-72) {
  min-height: 18rem;
}

.mtw :is(.min-h-\\[80px\\]) {
  min-height: 80px;
}

.mtw :is(.w-1) {
  width: 0.25rem;
}

.mtw :is(.w-10) {
  width: 2.5rem;
}

.mtw :is(.w-12) {
  width: 3rem;
}

.mtw :is(.w-2) {
  width: 0.5rem;
}

.mtw :is(.w-20) {
  width: 5rem;
}

.mtw :is(.w-3) {
  width: 0.75rem;
}

.mtw :is(.w-3\\.5) {
  width: 0.875rem;
}

.mtw :is(.w-4) {
  width: 1rem;
}

.mtw :is(.w-40) {
  width: 10rem;
}

.mtw :is(.w-5) {
  width: 1.25rem;
}

.mtw :is(.w-\\[20\\%\\]) {
  width: 20%;
}

.mtw :is(.w-\\[500px\\]) {
  width: 500px;
}

.mtw :is(.w-\\[60\\%\\]) {
  width: 60%;
}

.mtw :is(.w-\\[80\\%\\]) {
  width: 80%;
}

.mtw :is(.w-full) {
  width: 100%;
}

.mtw :is(.min-w-\\[500px\\]) {
  min-width: 500px;
}

.mtw :is(.min-w-\\[8rem\\]) {
  min-width: 8rem;
}

.mtw :is(.max-w-lg) {
  max-width: 32rem;
}

.mtw :is(.shrink) {
  flex-shrink: 1;
}

.mtw :is(.shrink-0) {
  flex-shrink: 0;
}

.mtw :is(.flex-grow) {
  flex-grow: 1;
}

.mtw :is(.grow) {
  flex-grow: 1;
}

.mtw :is(.basis-0) {
  flex-basis: 0px;
}

.mtw :is(.translate-x-\\[-50\\%\\]) {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.mtw :is(.translate-y-\\[-50\\%\\]) {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}

.mtw :is(.animate-bounce) {
  animation: bounce 1s infinite;
}

@keyframes pulse {

  50% {
    opacity: .5;
  }
}

.mtw :is(.animate-pulse) {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}

.mtw :is(.animate-spin) {
  animation: spin 1s linear infinite;
}

.mtw :is(.cursor-default) {
  cursor: default;
}

.mtw :is(.cursor-pointer) {
  cursor: pointer;
}

.mtw :is(.select-none) {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.mtw :is(.grid-cols-12) {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.mtw :is(.grid-cols-\\[auto\\2c 1fr\\2c auto\\]) {
  grid-template-columns: auto 1fr auto;
}

.mtw :is(.flex-row) {
  flex-direction: row;
}

.mtw :is(.flex-col) {
  flex-direction: column;
}

.mtw :is(.flex-col-reverse) {
  flex-direction: column-reverse;
}

.mtw :is(.flex-wrap) {
  flex-wrap: wrap;
}

.mtw :is(.content-center) {
  align-content: center;
}

.mtw :is(.items-start) {
  align-items: flex-start;
}

.mtw :is(.items-end) {
  align-items: flex-end;
}

.mtw :is(.items-center) {
  align-items: center;
}

.mtw :is(.justify-start) {
  justify-content: flex-start;
}

.mtw :is(.justify-end) {
  justify-content: flex-end;
}

.mtw :is(.justify-center) {
  justify-content: center;
}

.mtw :is(.justify-between) {
  justify-content: space-between;
}

.mtw :is(.gap-1) {
  gap: 0.25rem;
}

.mtw :is(.gap-2) {
  gap: 0.5rem;
}

.mtw :is(.gap-2\\.5) {
  gap: 0.625rem;
}

.mtw :is(.gap-3) {
  gap: 0.75rem;
}

.mtw :is(.gap-4) {
  gap: 1rem;
}

.mtw :is(.gap-6) {
  gap: 1.5rem;
}

.mtw :is(.space-x-1 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.mtw :is(.space-y-1 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.mtw :is(.space-y-1\\.5 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}

.mtw :is(.self-stretch) {
  align-self: stretch;
}

.mtw :is(.overflow-hidden) {
  overflow: hidden;
}

.mtw :is(.overflow-x-auto) {
  overflow-x: auto;
}

.mtw :is(.whitespace-nowrap) {
  white-space: nowrap;
}

.mtw :is(.rounded-full) {
  border-radius: 9999px;
}

.mtw :is(.rounded-lg) {
  border-radius: var(--radius);
}

.mtw :is(.rounded-md) {
  border-radius: calc(var(--radius) - 2px);
}

.mtw :is(.rounded-sm) {
  border-radius: calc(var(--radius) - 4px);
}

.mtw :is(.rounded-xl) {
  border-radius: 0.75rem;
}

.mtw :is(.border) {
  border-width: 1px;
}

.mtw :is(.border-0) {
  border-width: 0px;
}

.mtw :is(.border-b) {
  border-bottom-width: 1px;
}

.mtw :is(.border-t) {
  border-top-width: 1px;
}

.mtw :is(.border-t-2) {
  border-top-width: 2px;
}

.mtw :is(.border-t-4) {
  border-top-width: 4px;
}

.mtw :is(.border-none) {
  border-style: none;
}

.mtw :is(.border-background-light) {
  border-color: hsl(var(--primary-light));
}

.mtw :is(.border-blue-400) {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}

.mtw :is(.border-danger-main) {
  --tw-border-opacity: 1;
  border-color: rgb(219 23 66 / var(--tw-border-opacity));
}

.mtw :is(.border-gray-300) {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.mtw :is(.border-gray-400) {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}

.mtw :is(.border-indigo-400) {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity));
}

.mtw :is(.border-input) {
  border-color: hsl(var(--input));
}

.mtw :is(.border-main-primary) {
  --tw-border-opacity: 1;
  border-color: rgb(67 104 248 / var(--tw-border-opacity));
}

.mtw :is(.border-rose-500) {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity));
}

.mtw :is(.border-transparent) {
  border-color: transparent;
}

.mtw :is(.bg-background) {
  background-color: hsl(var(--background));
}

.mtw :is(.bg-background-filter-selected) {
  background-color: hsl(var(--filter-selected-background));
}

.mtw :is(.bg-black\\/30) {
  background-color: rgb(0 0 0 / 0.3);
}

.mtw :is(.bg-card) {
  background-color: hsl(var(--card));
}

.mtw :is(.bg-card-installed) {
  background-color: hsl(var(--card-installed));
}

.mtw :is(.bg-danger-main) {
  --tw-bg-opacity: 1;
  background-color: rgb(219 23 66 / var(--tw-bg-opacity));
}

.mtw :is(.bg-destructive) {
  background-color: hsl(var(--destructive));
}

.mtw :is(.bg-gray-100) {
  --tw-bg-opacity: 1;
  background-color: rgb(65 69 84 / var(--tw-bg-opacity));
}

.mtw :is(.bg-gray-20) {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}

.mtw :is(.bg-main-primary) {
  --tw-bg-opacity: 1;
  background-color: rgb(67 104 248 / var(--tw-bg-opacity));
}

.mtw :is(.bg-main-secondary) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.mtw :is(.bg-muted) {
  background-color: hsl(var(--muted));
}

.mtw :is(.bg-popover) {
  background-color: hsl(var(--popover));
}

.mtw :is(.bg-primary) {
  background-color: hsl(var(--primary));
}

.mtw :is(.bg-secondary) {
  background-color: hsl(var(--secondary));
}

.mtw :is(.bg-skeleton) {
  background-color: hsl(var(--skeleton));
}

.mtw :is(.bg-skeleton-foreground) {
  background-color: hsl(var(--skeleton-foreground));
}

.mtw :is(.bg-transparent) {
  background-color: transparent;
}

.mtw :is(.bg-violet-950) {
  --tw-bg-opacity: 1;
  background-color: rgb(46 16 101 / var(--tw-bg-opacity));
}

.mtw :is(.bg-white) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.mtw :is(.fill-current) {
  fill: currentColor;
}

.mtw :is(.p-1) {
  padding: 0.25rem;
}

.mtw :is(.p-2) {
  padding: 0.5rem;
}

.mtw :is(.p-4) {
  padding: 1rem;
}

.mtw :is(.p-6) {
  padding: 1.5rem;
}

.mtw :is(.px-12) {
  padding-left: 3rem;
  padding-right: 3rem;
}

.mtw :is(.px-2) {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.mtw :is(.px-2\\.5) {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.mtw :is(.px-3) {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.mtw :is(.px-4) {
  padding-left: 1rem;
  padding-right: 1rem;
}

.mtw :is(.px-5) {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.mtw :is(.px-8) {
  padding-left: 2rem;
  padding-right: 2rem;
}

.mtw :is(.py-0) {
  padding-top: 0px;
  padding-bottom: 0px;
}

.mtw :is(.py-0\\.5) {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.mtw :is(.py-1) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.mtw :is(.py-1\\.5) {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.mtw :is(.py-2) {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.mtw :is(.py-3) {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.mtw :is(.py-5) {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.mtw :is(.pb-2) {
  padding-bottom: 0.5rem;
}

.mtw :is(.pl-8) {
  padding-left: 2rem;
}

.mtw :is(.pr-2) {
  padding-right: 0.5rem;
}

.mtw :is(.pt-0) {
  padding-top: 0px;
}

.mtw :is(.pt-4) {
  padding-top: 1rem;
}

.mtw :is(.text-center) {
  text-align: center;
}

.mtw :is(.font-poppins) {
  font-family: Poppins, sans-serif;
}

.mtw :is(.text-2xl) {
  font-size: 1.5rem;
  line-height: 2rem;
}

.mtw :is(.text-9xl) {
  font-size: 8rem;
  line-height: 1;
}

.mtw :is(.text-\\[1\\.75rem\\]) {
  font-size: 1.75rem;
}

.mtw :is(.text-base) {
  font-size: 1rem;
  line-height: 1.5rem;
}

.mtw :is(.text-lg) {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.mtw :is(.text-sm) {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.mtw :is(.text-xl) {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.mtw :is(.text-xs) {
  font-size: 0.75rem;
  line-height: 1rem;
}

.mtw :is(.font-bold) {
  font-weight: 700;
}

.mtw :is(.font-light) {
  font-weight: 300;
}

.mtw :is(.font-medium) {
  font-weight: 500;
}

.mtw :is(.font-normal) {
  font-weight: 400;
}

.mtw :is(.font-semibold) {
  font-weight: 600;
}

.mtw :is(.leading-10) {
  line-height: 2.5rem;
}

.mtw :is(.leading-7) {
  line-height: 1.75rem;
}

.mtw :is(.leading-none) {
  line-height: 1;
}

.mtw :is(.leading-relaxed) {
  line-height: 1.625;
}

.mtw :is(.leading-snug) {
  line-height: 1.375;
}

.mtw :is(.leading-tight) {
  line-height: 1.25;
}

.mtw :is(.tracking-tight) {
  letter-spacing: -0.025em;
}

.mtw :is(.tracking-widest) {
  letter-spacing: 0.1em;
}

.mtw :is(.text-background-light) {
  color: hsl(var(--primary-light));
}

.mtw :is(.text-black) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.mtw :is(.text-card-foreground) {
  color: hsl(var(--card-foreground));
}

.mtw :is(.text-danger-main) {
  --tw-text-opacity: 1;
  color: rgb(219 23 66 / var(--tw-text-opacity));
}

.mtw :is(.text-destructive-foreground) {
  color: hsl(var(--destructive-foreground));
}

.mtw :is(.text-foreground) {
  color: hsl(var(--foreground));
}

.mtw :is(.text-gray-100) {
  --tw-text-opacity: 1;
  color: rgb(65 69 84 / var(--tw-text-opacity));
}

.mtw :is(.text-gray-50) {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}

.mtw :is(.text-gray-600) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.mtw :is(.text-gray-700) {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.mtw :is(.text-indigo-500) {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity));
}

.mtw :is(.text-light) {
  color: hsl(var(--primary-light));
}

.mtw :is(.text-main-primary) {
  --tw-text-opacity: 1;
  color: rgb(67 104 248 / var(--tw-text-opacity));
}

.mtw :is(.text-muted-foreground) {
  color: hsl(var(--muted-foreground));
}

.mtw :is(.text-neutral-400) {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity));
}

.mtw :is(.text-popover-foreground) {
  color: hsl(var(--popover-foreground));
}

.mtw :is(.text-primary) {
  color: hsl(var(--primary));
}

.mtw :is(.text-primary-foreground) {
  color: hsl(var(--primary-foreground));
}

.mtw :is(.text-red-700) {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}

.mtw :is(.text-rose-500) {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity));
}

.mtw :is(.text-secondary) {
  color: hsl(var(--secondary));
}

.mtw :is(.text-secondary-foreground) {
  color: hsl(var(--secondary-foreground));
}

.mtw :is(.text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.mtw :is(.text-white\\/90) {
  color: rgb(255 255 255 / 0.9);
}

.mtw :is(.underline) {
  text-decoration-line: underline;
}

.mtw :is(.underline-offset-4) {
  text-underline-offset: 4px;
}

.mtw :is(.opacity-60) {
  opacity: 0.6;
}

.mtw :is(.opacity-70) {
  opacity: 0.7;
}

.mtw :is(.shadow) {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.mtw :is(.shadow-\\[inset_0_1px_0_0_rgba\\(255\\2c 255\\2c 255\\2c 0\\.1\\)\\]) {
  --tw-shadow: inset 0 1px 0 0 rgba(255,255,255,0.1);
  --tw-shadow-colored: inset 0 1px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.mtw :is(.shadow-lg) {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.mtw :is(.shadow-md) {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.mtw :is(.shadow-sm) {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.mtw :is(.shadow-xl) {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.mtw :is(.outline-none) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.mtw :is(.outline) {
  outline-style: solid;
}

.mtw :is(.outline-0) {
  outline-width: 0px;
}

.mtw :is(.outline-2) {
  outline-width: 2px;
}

.mtw :is(.outline-offset-2) {
  outline-offset: 2px;
}

.mtw :is(.outline-main-focus) {
  outline-color: #FF8863;
}

.mtw :is(.ring-1) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.mtw :is(.ring-offset-background) {
  --tw-ring-offset-color: hsl(var(--background));
}

.mtw :is(.filter) {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.mtw :is(.transition) {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.mtw :is(.transition-all) {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.mtw :is(.transition-colors) {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.mtw :is(.transition-opacity) {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.mtw :is(.delay-200) {
  transition-delay: 200ms;
}

.mtw :is(.duration-200) {
  transition-duration: 200ms;
}

@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}

@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}

.mtw :is(.duration-200) {
  animation-duration: 200ms;
}

.mtw :is(.delay-200) {
  animation-delay: 200ms;
}

.mtw :is(.file\\:border-0)::file-selector-button {
  border-width: 0px;
}

.mtw :is(.file\\:bg-transparent)::file-selector-button {
  background-color: transparent;
}

.mtw :is(.file\\:text-sm)::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.mtw :is(.file\\:font-medium)::file-selector-button {
  font-weight: 500;
}

.mtw :is(.placeholder\\:text-muted-foreground)::-moz-placeholder {
  color: hsl(var(--muted-foreground));
}

.mtw :is(.placeholder\\:text-muted-foreground)::placeholder {
  color: hsl(var(--muted-foreground));
}

.mtw :is(.hover\\:cursor-pointer:hover) {
  cursor: pointer;
}

.mtw :is(.hover\\:bg-accent:hover) {
  background-color: hsl(var(--accent));
}

.mtw :is(.hover\\:bg-danger-hover:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(181 14 50 / var(--tw-bg-opacity));
}

.mtw :is(.hover\\:bg-destructive\\/90:hover) {
  background-color: hsl(var(--destructive) / 0.9);
}

.mtw :is(.hover\\:bg-gray-20:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}

.mtw :is(.hover\\:bg-indigo-100:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}

.mtw :is(.hover\\:bg-main-hover:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 83 191 / var(--tw-bg-opacity));
}

.mtw :is(.hover\\:bg-primary\\/90:hover) {
  background-color: hsl(var(--primary) / 0.9);
}

.mtw :is(.hover\\:bg-rose-100:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity));
}

.mtw :is(.hover\\:bg-secondary\\/90:hover) {
  background-color: hsl(var(--secondary) / 0.9);
}

.mtw :is(.hover\\:bg-white:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.mtw :is(.hover\\:text-accent-foreground:hover) {
  color: hsl(var(--accent-foreground));
}

.mtw :is(.hover\\:text-gray-50:hover) {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}

.mtw :is(.hover\\:text-white:hover) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.mtw :is(.hover\\:underline:hover) {
  text-decoration-line: underline;
}

.mtw :is(.hover\\:opacity-100:hover) {
  opacity: 1;
}

.mtw :is(.hover\\:shadow-2xl:hover) {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.mtw :is(.focus\\:bg-accent:focus) {
  background-color: hsl(var(--accent));
}

.mtw :is(.focus\\:bg-transparent:focus) {
  background-color: transparent;
}

.mtw :is(.focus\\:text-accent-foreground:focus) {
  color: hsl(var(--accent-foreground));
}

.mtw :is(.focus\\:outline-none:focus) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.mtw :is(.focus\\:ring-2:focus) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.mtw :is(.focus\\:ring-ring:focus) {
  --tw-ring-color: hsl(var(--ring));
}

.mtw :is(.focus\\:ring-offset-2:focus) {
  --tw-ring-offset-width: 2px;
}

.mtw :is(.focus-visible\\:outline-none:focus-visible) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.mtw :is(.focus-visible\\:ring-2:focus-visible) {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.mtw :is(.focus-visible\\:ring-ring:focus-visible) {
  --tw-ring-color: hsl(var(--ring));
}

.mtw :is(.focus-visible\\:ring-offset-2:focus-visible) {
  --tw-ring-offset-width: 2px;
}

.mtw :is(.disabled\\:pointer-events-none:disabled) {
  pointer-events: none;
}

.mtw :is(.disabled\\:cursor-not-allowed:disabled) {
  cursor: not-allowed;
}

.mtw :is(.disabled\\:bg-transparent:disabled) {
  background-color: transparent;
}

.mtw :is(.disabled\\:opacity-50:disabled) {
  opacity: 0.5;
}

.mtw :is(.peer:disabled ~ .peer-disabled\\:cursor-not-allowed) {
  cursor: not-allowed;
}

.mtw :is(.peer:disabled ~ .peer-disabled\\:opacity-70) {
  opacity: 0.7;
}

.mtw :is(.data-\\[disabled\\]\\:pointer-events-none[data-disabled]) {
  pointer-events: none;
}

.mtw :is(.data-\\[state\\=active\\]\\:border-indigo-600[data-state=active]) {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity));
}

.mtw :is(.data-\\[state\\=open\\]\\:bg-accent[data-state=open]) {
  background-color: hsl(var(--accent));
}

.mtw :is(.data-\\[state\\=active\\]\\:text-indigo-500[data-state=active]) {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity));
}

.mtw :is(.data-\\[state\\=open\\]\\:text-muted-foreground[data-state=open]) {
  color: hsl(var(--muted-foreground));
}

.mtw :is(.data-\\[disabled\\]\\:opacity-50[data-disabled]) {
  opacity: 0.5;
}

.mtw :is(.data-\\[state\\=open\\]\\:animate-in[data-state=open]) {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.mtw :is(.data-\\[state\\=closed\\]\\:animate-out[data-state=closed]) {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.mtw :is(.data-\\[state\\=closed\\]\\:fade-out-0[data-state=closed]) {
  --tw-exit-opacity: 0;
}

.mtw :is(.data-\\[state\\=open\\]\\:fade-in-0[data-state=open]) {
  --tw-enter-opacity: 0;
}

.mtw :is(.data-\\[state\\=closed\\]\\:zoom-out-95[data-state=closed]) {
  --tw-exit-scale: .95;
}

.mtw :is(.data-\\[state\\=open\\]\\:zoom-in-95[data-state=open]) {
  --tw-enter-scale: .95;
}

.mtw :is(.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side=bottom]) {
  --tw-enter-translate-y: -0.5rem;
}

.mtw :is(.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side=left]) {
  --tw-enter-translate-x: 0.5rem;
}

.mtw :is(.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side=right]) {
  --tw-enter-translate-x: -0.5rem;
}

.mtw :is(.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side=top]) {
  --tw-enter-translate-y: 0.5rem;
}

.mtw :is(.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state=closed]) {
  --tw-exit-translate-x: -50%;
}

.mtw :is(.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state=closed]) {
  --tw-exit-translate-y: -48%;
}

.mtw :is(.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state=open]) {
  --tw-enter-translate-x: -50%;
}

.mtw :is(.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state=open]) {
  --tw-enter-translate-y: -48%;
}

@media (min-width: 640px) {

  .mtw :is(.sm\\:flex-row) {
    flex-direction: row;
  }

  .mtw :is(.sm\\:justify-end) {
    justify-content: flex-end;
  }

  .mtw :is(.sm\\:space-x-2 > :not([hidden]) ~ :not([hidden])) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .mtw :is(.sm\\:rounded-lg) {
    border-radius: var(--radius);
  }

  .mtw :is(.sm\\:text-left) {
    text-align: left;
  }
}

@media (min-width: 768px) {

  .mtw :is(.md\\:grid) {
    display: grid;
  }

  .mtw :is(.md\\:w-full) {
    width: 100%;
  }

  .mtw :is(.md\\:grid-cols-4) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (prefers-color-scheme: dark) {

  .mtw :is(.dark\\:shadow-none) {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .mtw :is(.dark\\:outline-main-focus) {
    outline-color: #FF8863;
  }
}

@media (forced-colors: active) {

  .mtw :is(.forced-colors\\:text-\\[GrayText\\]) {
    color: GrayText;
  }

  .mtw :is(.forced-colors\\:outline-\\[Highlight\\]) {
    outline-color: Highlight;
  }
}
`, "",{"version":3,"sources":["webpack://./../../libs/ui/src/styles.css"],"names":[],"mappings":"AAAA;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;IAAA,uBAAc;IAAd,2BAAc;;IAAd,sBAAc;IAAd,qCAAc;;IAAd,oBAAc;IAAd,oCAAc;;IAAd,iBAAc;IAAd,iCAAc;IAAd,6BAAc,EAAd,YAAc;;IAAd,2BAAc;IAAd,0BAAc;;IAAd,sBAAc;IAAd,iCAAc;;IAAd,wBAAc;IAAd,yCAAc;;IAAd,uBAAc;IAAd,sCAAc;;IAAd,0BAAc;IAAd,qCAAc;;IAAd,uBAAc;;IAAd,gBAAc;;IAAd,aAAc;IAAd,sBAAc;IAAd,iCAAc;;IAAd,gBAAc;IAAd,6BAAc,EAAd,YAAc;IAAd,mCAAc,EAAd,YAAc;IAAd,qCAAc,EAAd,YAAc;IAAd,gCAAc,EAAd,YAAc;IAAd,8BAAc,EAAd,YAAc;IAAd,2CAAc,EAAd,+CAAc;IAAd,sCAAc,EAAd,YAAc;IAAd,kCAAc,EAAd,YAAc;IAAd,gCAAc,EAAd,YAAc;;IAAd,YAAc;IAAd,6BAAc,EAAd,YAAc;IAAd,iCAAc,EAAd,YAAc;IAAd,iCAAc,EAAd,YAAc;;IAAd,oBAAc;IAAd,6BAAc,EAAd,YAAc;IAAd,8BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,6BAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,sCAAc,EAAd,YAAc;EAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AACd;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;;AAApB;;EAAA;IAAA;EAAoB;AAAA;;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;;AAAnB;EAAA;AAAmB;;AAAnB;;EAAA;IAAA;EAAmB;AAAA;;AAAnB;EAAA;AAAmB;;AAAnB;;EAAA;IAAA;EAAmB;AAAA;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;;AAAnB;EAAA,kDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;;AAAnB;EAAA;AAAmB;;AAAnB;EAAA;AAAmB;;AAFnB;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,mBAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,kBAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,kBAoEA;EApEA;AAoEA;;AApEA;EAAA,kBAoEA;EApEA;AAoEA;;AApEA;EAAA,kBAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,kBAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,kBAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,oBAoEA;EApEA;AAoEA;;AApEA;EAAA,oBAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,gDAoEA;EApEA,6DAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,8BAoEA;EApEA;AAoEA;;AApEA;EAAA,2GAoEA;EApEA,yGAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,8BAoEA;EApEA;AAoEA;;AApEA;EAAA,2GAoEA;EApEA,yGAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,sBAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,oBAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA,qBAoEA;EApEA,yBAoEA;EApEA,2BAoEA;EApEA,yBAoEA;EApEA,0BAoEA;EApEA,+BAoEA;EApEA;AAoEA;;AApEA;EAAA,oBAoEA;EApEA,yBAoEA;EApEA,0BAoEA;EApEA,wBAoEA;EApEA,yBAoEA;EApEA,8BAoEA;EApEA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;EAAA;AAoEA;;AApEA;;EAAA;IAAA;EAoEA;;EApEA;IAAA;EAoEA;;EApEA;IAAA,uBAoEA;IApEA,sDAoEA;IApEA;EAoEA;;EApEA;IAAA;EAoEA;;EApEA;IAAA;EAoEA;AAAA;;AApEA;;EAAA;IAAA;EAoEA;;EApEA;IAAA;EAoEA;;EApEA;IAAA;EAoEA;AAAA;;AApEA;;EAAA;IAAA,sBAoEA;IApEA,8BAoEA;IApEA;EAoEA;;EApEA;IAAA;EAoEA;AAAA;;AApEA;;EAAA;IAAA;EAoEA;;EApEA;IAAA;EAoEA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  .mtw {\n    --background: 0 0% 100%;\n    --foreground: 248, 88%, 19%;\n\n    --muted: 210 40% 96.1%;\n    --muted-foreground: 215.4 16.3% 46.9%;\n\n    --popover: 0 0% 100%;\n    --popover-foreground: 222.2 84% 4.9%;\n\n    --card: 0 0% 100%;\n    --card-foreground: 222.2 84% 4.9%;\n    --card-installed: 223 33% 96%; /* #F1F3F8 */\n\n    --border: 214.3 31.8% 91.4%;\n    --input: 214.3 31.8% 91.4%;\n\n    --primary: 229 20% 30%;\n    --primary-foreground: 210 40% 98%;\n\n    --secondary: 248 88% 19%;\n    --secondary-foreground: 222.2 47.4% 11.2%;\n\n    --accent: 210 40% 96.1%;\n    --accent-foreground: 222.2 47.4% 11.2%;\n\n    --destructive: 353 72% 43%;\n    --destructive-foreground: 210 40% 98%;\n\n    --ring: 215 20.2% 65.1%;\n\n    --radius: 0.5rem;\n\n    /* Skeleton */\n    --skeleton: 0, 0%, 96%;\n    --skeleton-foreground: 0, 0%, 85%;\n\n    /* Backgrounds */\n    --primary-dark: 248, 77%, 21%; /* #1C1769 */\n    --background-default: 220, 22%, 98%; /* #F7F8FA */\n    --background-installed: 223, 14%, 96%; /* #F1F3F8 */\n    --primary-default: 248, 88%, 19%; /* #17125B */\n    --primary-light: 223, 89%, 60%; /* #4368F8 */\n    --filter-selected-background: 223, 89%, 90%; /* approximated from rgba(67, 104, 248, 0.10) */\n    --background-navigation: 223, 24%, 97%; /* #F3F6FA */\n    --background-detail: 223, 28%, 94%; /* #E9EFF6 */\n    --background-loading: 0, 0%, 96%; /* #F5F5F5 */\n\n    /* Accents */\n    --accent-error: 353, 72%, 43%; /* #B50E32 */\n    --accent-highlight: 342, 88%, 66%; /* #EB315A */\n    --section-selected: 232, 59%, 51%; /* #3753BF */\n\n    /* Texts & Borders */\n    --border-hover: 234, 12%, 95%; /* #EAEAF4 */\n    --border-default: 235, 8%, 96%; /* #F3F3F9 */\n    --border-active: 0, 0%, 85%; /* #D9D9D9 */\n    --text-default: 229, 20%, 30%; /* #414554 */\n    --text-info: 0, 0%, 66%; /* #A9A9A9 */\n    --text-subtle: 0, 0%, 55%; /* #8D8D8D */\n    --filter-active-background: 0, 0%, 94%; /* #F0F0F0 */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
